<template>
  <div class="menu-item">
    <!-- main menu item -->
    <div
      class="item-all"
      :class="linkClass"
      @click="itemClicked"
      @mouseenter="hoverStart"
      @mouseleave="hoverStop"
    >
      <div class="item-all-inside">
        <div
          class="item-logo"
          :class="item.icon"
          v-if="!(getMenu === 'small' && item.routerLinks.length === 1)"
        ></div>
        <div
          v-if="item.menuSublist.length > 0 && getMenu === 'full'"
          class="item-name"
        >
          {{ item.name }}
        </div>
        <!-- если всего одна страница в разделе и меню раскрыто -->
        <router-link
          v-else-if="getMenu === 'full'"
          class="item-name"
          tag="div"
          :to="{ name: item.routerLinks[0] }"
          >{{ item.name }}</router-link
        >
        <!-- одна страница в разделе и меню закрыто (навигация по нажатию на лого) -->
        <router-link
          v-else-if="getMenu === 'small' && item.routerLinks.length === 1"
          class="item-logo"
          :class="item.icon"
          tag="div"
          :to="{ name: item.routerLinks[0] }"
        ></router-link>
      </div>
      <i
        v-if="item.menuSublist.length > 0 && getMenu === 'full'"
        class="el-icon-arrow-down arrow-down"
      ></i>
    </div>
    <!-- sublist beneath main menu item-->
    <div
      class="item-sublist"
      :class="subClass"
      @mouseenter="hoverStart"
      @mouseleave="hoverStop"
      v-if="showSublist && item.menuSublist.length > 0"
    >
      <div v-if="getMenu === 'small'" class="sublist-title">
        {{ item.name }}
      </div>

      <span v-for="(subitem, index) in item.menuSublist" :key="index">
        <router-link
          tag="div"
          class="item-sublist-item"
          active-class="sub-link-active"
          :to="{ name: item.routerLinks[index] }"
          >{{ subitem }}</router-link
        >
      </span>
    </div>
    <div
      v-else-if="
        showSublist && getMenu === 'small' && item.routerLinks.length === 1
      "
      class="item-sublist"
      :class="subClass"
      @mouseenter="hoverStart"
      @mouseleave="hoverStop"
    >
      <div class="sublist-title">{{ item.name }}</div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      showSublist: false,
      linkClass: "",
      subClass: "",
    };
  },
  methods: {
    itemClicked() {
      this.showSublist = !this.showSublist;
    },
    hoverStart() {
      if (this.getMenu === "small") {
        this.subClass = "hoverable";
        this.showSublist = true;
        // this.borderRadius = "0 0 0 0";
      }
    },
    hoverStop() {
      if (this.getMenu === "small") {
        this.subClass = "";
        this.showSublist = false;
        // this.borderRadius = "0px 20px 20px 0px";
      }
    },
  },
  created() {
    if (this.item.routerLinks.includes(this.$route.name)) {
      this.linkClass = "link-active";
    } else {
      this.linkClass = "";
    }
  },
  watch: {
    $route(to) {
      if (this.item.routerLinks.includes(to.name)) {
        this.linkClass = "link-active";
      } else {
        this.linkClass = "";
      }
    },
    getMenu() {
      if (this.getMenu === "small") {
        this.showSublist = false;
      }
    },
  },
  computed: {
    ...mapGetters(["getMenu"]),
  },
};
</script>


<style scoped>
.item-logo {
  transform: scale(1.1);
  margin: 17px 0px 16px 12px;
  font-weight: var(--menu-weight);
}

.arrow-down {
  margin-top: 17px;
  margin-right: 5px;
}

.item-all {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  justify-content: space-between;
  color: var(--menu-text-color);
  -moz-user-select: none;
  -webkit-user-select: none;
}

.item-all:hover {
  background-color: var(--off-background-hover);
  color: var(--menu-text-color-hover);
}
.item-all:active {
  color: var(--menu-text-color-hover);
}

.link-active {
  background: var(--off-background-selected) !important;
}
.link-active .item-all-inside {
  box-shadow: -3px 0px 0px 0px var(--active-color);
}
.item-all-inside {
  margin-left: 3px;
  display: flex;
}
.sub-link-active {
  color: var(--active-color) !important;
  background-color: var(--off-background-hover);
}
.item-name {
  line-height: 29px;
  padding: 10px;
  font-weight: var(--menu-weight);
}

.item-sublist {
  padding-left: 30px;
  padding-top: 0px;
  margin-bottom: 2em;
  font-weight: var(--menu-weight);
}

.item-sublist.hoverable {
  position: fixed;
  background-color: var(--off-background);
  margin-left: var(--nav-left-small);
  margin-top: -49px;
  padding: 4px 10px;
}
.item-sublist.hoverable .item-sublist-item::before {
  content: "";
}
.item-sublist.hoverable .item-sublist-item:not(:nth-last-of-type(1)) {
  margin-bottom: 10px;
}
.item-sublist.hoverable .item-sublist-item:nth-last-of-type(1) {
  margin-bottom: 15px;
}

.sublist-title {
  font-weight: 600;
  margin: 10px 0px;
  padding-bottom: 10px;
  cursor: default;
  color: var(--menu-text-color);
  font-size: 1.05em;
  border-bottom: 1px solid var(--menu-text-color);
}

.item-sublist-item {
  cursor: pointer;
  color: var(--menu-text-color);
  margin: 5px 2px;
}
.item-sublist-item:hover {
  background-color: var(--off-background-hover);
  color: var(--menu-text-color-hover);
}
</style>